import React, { useEffect, useState, Fragment } from "react";
import {
  Box,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import Input from "../../../../components/uiElements/input/Input";
import Dialog from "../../../../components/uiElements/modal";
import Button from "../../../../components/uiElements/button";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { addAgentRecruitmentTags } from "../../../../redux/agents/agentRecruitment/addAgentRecruitmentTags";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import ViewportList from "react-viewport-list";
import ResponseAlert from "../../../../components/responseAlert";

export const AddTagsModal = ({ closeModal, tagsList, state, prevTags, id, ...props }) => {
  const [searchTag, setSearchTag] = useState("");
  const [selectedTagsList, setSelectedTagsList] = useState(prevTags || []);
  const [filteredTagsList, setFilteredTagsList] = useState(tagsList);
  const [tagsListArr, setTagsListArr] = useState(tagsList);
  const [errorAlert, setErrorAlert] = useState({
    errorMsg: "",
    errorType: "",
    isOpen: false,
  });

  const dispatch = useDispatch();
  const { loading: actionLoading } = useSelector((item) => item.agentProfile.agentProfile.modalActions);


  useEffect(() => {
    if (state) {
      setSelectedTagsList(prevTags?.map((it)=>it.tag) || []);
      setFilteredTagsList(tagsList)
      setTagsListArr(tagsList)
    }
  }, [state]);

  const handleSuccess = () => {
    setErrorAlert({
      errorMsg: "You have successfully updated the tags",
      errorType: "success",
      isOpen: true,
    });
    closeModal();
  };
  const handleError = (error) => {
    setErrorAlert({
      errorMsg: error ? JSON.stringify(error) : "Something went wrong please try later",
      errorType: "error",
      isOpen: true,
    });
  };

  const saveTags = () => {
    dispatch(addAgentRecruitmentTags({ tags: selectedTagsList, id, handleSuccess, handleError }));
  };
  return (
    <Fragment>
      <Dialog
        disablePortal
        sx={{ "& .MuiDialog-container": { mt: "30px" } }}
        dialogHead={<DialogHead />}
        onSave={saveTags}
        dialogBody={
          <DialogBody
            setSelectedTagsList={setSelectedTagsList}
            selectedTagsList={selectedTagsList}
            tagsList={tagsListArr}
            setTagsList={setTagsListArr}
            filteredTagsList={filteredTagsList}
            setFilteredTagsList={setFilteredTagsList}
            setSearchTag={setSearchTag}
            searchTag={searchTag}
          />
        }
        dialogFooter={<DialogFooter />}
        state={state}
        closeModal={closeModal}
        maxWidth="md"
        loading={actionLoading}
        fullWidth={true}
      />
      <ResponseAlert
        open={errorAlert.isOpen}
        setOpen={() => setErrorAlert({ errorMsg: "", errorType: "", isOpen: false })}
        alertType={errorAlert.errorType}
        alertMessage={errorAlert.errorMsg}
      />
    </Fragment>
  );
};

// Components
const AddTaskForm = ({ mb, tagsList, setFilteredTagsList, setSearchTag, searchTag }) => {
  const changeInputSearchFn = (event) => {
    const InputValue = event.target.value;
    setSearchTag(InputValue);
    const filterArray = tagsList.filter((el) => el.name.toLowerCase().includes(InputValue.toLowerCase()));
    if (filterArray?.length) {
      setFilteredTagsList(filterArray);
    } else if (!InputValue.trim()) {
      setFilteredTagsList(tagsList);
    } else {
      setFilteredTagsList([]);
    }
  };
  return (
    <>
      <Box sx={{ display: "block", marginBottom: "10px" }}></Box>
      <Grid container direction="row" justifyContent="center" alignItems="center" spacing={1} sx={{ flexGrow: 1, marginBottom: mb || 0 }}>
        <Grid item sm={12}>
          <Input placeholder="Search for tags..." onChange={changeInputSearchFn} value={searchTag} />
        </Grid>
      </Grid>
    </>
  );
};

const DialogHead = () => (
  <DialogTitle>
    <Typography component="h5" variant="h5">
      Tags
    </Typography>
  </DialogTitle>
);

const DialogBody = ({
  tagsList,
  setTagsList,
  filteredTagsList,
  setFilteredTagsList,
  setSearchTag,
  searchTag,
  setSelectedTagsList,
  selectedTagsList,
}) => {
  const ref = useRef(null);
  const addNewTagFunc = () => {
    setFilteredTagsList((prev) => [...tagsList, { name: searchTag.trim() }]);
    setTagsList((prev) => [...tagsList, { name: searchTag.trim() }]);
    setSelectedTagsList((prev) => [...prev, searchTag.trim()]);
    setSearchTag("");
  };

  const handleToggle = (e, value) => {
    const currentIndex = selectedTagsList.indexOf(value.name);
    const newChecked = [...selectedTagsList];

    if (currentIndex === -1) {
      newChecked.push(value.name);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setSelectedTagsList([...newChecked]);
  };

  return (
    <DialogContent>
      <AddTaskForm setFilteredTagsList={setFilteredTagsList} tagsList={tagsList} setSearchTag={setSearchTag} searchTag={searchTag} />
      <br />

      {filteredTagsList.length <= 0 ? (
        <Button variant="text" themeVersion startIcon={<AddCircleIcon />} onClick={addNewTagFunc}>
          Create new tag “{searchTag}”
        </Button>
      ) : (
        <List
          sx={{
            width: "100%",
            maxWidth: "100%",
            bgcolor: "background.paper",
            height: "calc(100vh - 400px)",
            overflow: "auto",
          }}
          ref={ref}
        >
          <ViewportList viewportRef={ref} items={filteredTagsList} itemMinSize={10} margin={8}>
            {(value) => (
              <ListItem key={value.id} disablePadding sx={{ borderBottom: "1px solid #c4c4c4 !important" }}>
                <ListItemButton role={undefined} onClick={(e) => handleToggle(e, value)} dense>
                  <ListItemIcon>
  
                    <Checkbox
                      edge="start"
                      checked={selectedTagsList.indexOf(value.name) !== -1}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ "aria-labelledby": value.id }}
                    />
                  </ListItemIcon>
                  <ListItemText id={`checkbox-list-label-${value.id}`} primary={value.name} />
                </ListItemButton>
              </ListItem>
            )}
          </ViewportList>
        </List>
      )}
    </DialogContent>
  );
};

const DialogFooter = () => (
  <DialogActions>
    <Typography component="p" variant="subtitle1">
      Footer Area
    </Typography>
  </DialogActions>
);
